import {
  AfterViewInit,
  Component,
  effect,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  input,
  OnChanges,
  OnDestroy,
  OnInit,
  output,
  Output,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { Table } from "primeng/table";
import { Routes } from "src/app/shared/models/kpi-details";
import { DataAccessService } from "src/app/shared/services/data-access/data-access.service";
import { DataRepositoryService } from "src/app/shared/services/data-repository/data-repository.service";
import { TaskInfoService } from "src/app/shared/services/task-info/task-info.service";
import { Column, DateType } from "src/app/modules/gantt/component/gantt/gantt.component";
import { RouteState } from "src/app/shared/entity/enums";
import { RoutesFilterComponent } from '../routes-filter/routes-filter.component';
import { ItemState } from "src/app/shared/models/core";
import * as d3 from "d3";
import { CommonService } from "src/app/shared/services/common/common.service";
import { Subscription, take } from "rxjs";
import { DatePipe } from "@angular/common";
import { MenuItem, MessageService, SortEvent } from "primeng/api";
import { AppConstants } from "src/app/shared/entity/constants";
import { RouteConfigurationService } from "../../home/dashboard/Service/route-configuration.service";
import { HttpStatusCode } from "@angular/common/http";
import { ErrorMessage, ErrorType } from "src/app/shared/entity/error.const";
import { KpiProgressPipe } from "src/app/shared/pipe/kpi-progress/kpi-progress.pipe";
import { ExportToExcelService } from "src/app/shared/services/export-to-excel/export-to-excel.service";
import { ColumnService } from "src/app/shared/services/column-services/column.service";
import { ColumnPreference } from "src/app/shared/models/column-preference";
import { SelectedPreferencesENUM } from "src/app/shared/models/preference";
import { ColumnPreferenceTab } from "../../setting/column-preference/column-preference.component";
import { KPIColumnService } from "../../home/dashboard/Service/kpi-column.service";
import {GANTT_LEGEND_COLORS} from 'src/app/shared/entity/color-codes';
import { Router } from "@angular/router";
import { Navigation } from "src/app/shared/entity/navigation";
import { ColorLegend } from "src/app/shared/entity/utility-interfaces";
import { DateFormatPipe, DateFormatType } from "src/app/shared/pipe/date-format-pipe/date-format.pipe";
import { Menu } from "primeng/menu";
import { MergeTaskDialogComponent } from "./merge-task-dialog/merge-task-dialog.component";

// Constants for breakpoints and fixed offsets
const BREAKPOINT_LARGE = 1600;
const BREAKPOINT_MEDIUM = 1024;
const GANTT_SIZE_DASHBOARD_PAGE = 35;
const GANTT_SIZE_GANTT_PAGE = 60;
// Minimum horizontal space each timeline tick gets. The gantt widens (and scrolls)
// so fine zoom levels keep legible, non-overlapping tick labels.
const MIN_PX_PER_TICK = 55;

interface TimelineLevel {
  label: string;
  tickFn: d3.TimeInterval;
}

const OFFSETS = {
  unifiedView: {
    large: { collapsed: 200, expanded: 400 },
    medium: { collapsed: 200, expanded: 800 },
    small: { collapsed: 200, expanded: 100 },
  },
  ganttView: {
    large: { collapsed: 50, expanded: 50 },
    medium: { collapsed: 50, expanded: 50 },
    small: { collapsed: 50, expanded: 50 },
  }
}

@Component({
    selector: "app-route-list",
    templateUrl: "./route-list.component.html",
    styleUrls: ['./route-list.component.scss', '../../../shared/css/primeng-table.component.scss', '../../../shared/css/primeng-dropdown.component.scss'],
    providers: [KpiProgressPipe],
    standalone: false
})


export class RouteListComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  @Output() sectionFullScreen = new EventEmitter();

  /**
   * In Order to enable the 
   * selection ability for the route.
   */
  @Input() isSelectionEnable = false;
  @ViewChild("kpiTable") kpiTable: Table;

  tooltip = d3.select('body')
  .append('div')
  .style('position', 'absolute')
  .style('pointer-events', 'none')
  .style('padding', '6px 10px')
  .style('background', '#fff')
  .style('color', '#171717')
  .style('border-radius', '4px')
  .style('font', '12px PNSans-Regular, sans-serif')
  .style('box-shadow', '0px 1px 10px #00000029')
  .style('border', '1px solid #CACACA')
  .style('opacity', '0');

  dateOffset = 0;
  event = "false";
  searchText: string = "";
  isFullScreen: boolean = false;
  taskPerHourRefConstant = 12.0;
  showRouteOptimization = false;
  showMergeTaskDialog = false;
  routesDetails: Routes = {} as Routes;
  itemColumnNames: Column[] = [];
  currentTimeInterval: any =null;
  //Gantt Param
  @ViewChild("ganttView") GanttViewElement: ElementRef;
  @ViewChild("ganttHeader") GanttHeaderElement: ElementRef;
  @ViewChild("ganttChart") chartContainer: ElementRef;
  @ViewChild("routeTable") routeTable: ElementRef;
  @ViewChild('splitRoot', { static: true, read: ElementRef }) splitRoot!: ElementRef;
  @ViewChild('menu') menu!: Menu;
  @ViewChild('mergeTaskDialogRef') mergeTaskDialogRef: MergeTaskDialogComponent;
  @ViewChild('routesFilter') routesFilter: RoutesFilterComponent;

  displayMovedInTasksDialog =false;
  displayPlannedAtLoadingDialog = false;
  margin: any = { top: 30, bottom: 20, left: 20, right: 8 };
  width: number;
  height: number = 2000;
  // Vertical spacing (in px) of a single Gantt route row. It is kept in sync with
  // the actual rendered height of a route table row so the two stay aligned. The
  // default (25) is used only until a real table row has been rendered, and must
  // match the `.p-datatable-tbody tr` height in route-list.component.scss.
  rowHeight: number = 25;
  subscription: Subscription[] = [];
  minDate: any;
  maxDate: any;
  routeList: any = [];
  x: any;
  noRecords = false;
  taskid: string = "";
  hasPersistedRouteFilter = false;
  timelineLevels: TimelineLevel[] = [
    {
      label: "30 min",
      tickFn: d3.timeMinute.every(30) ?? d3.timeMinute,
    },
    {
      label: "1 hr",
      tickFn: d3.timeHour.every(1) ?? d3.timeHour,
    },
    {
      label: "2 hr",
      tickFn: d3.timeHour.every(2) ?? d3.timeHour,
    },
    {
      label: "3 hr",
      tickFn: d3.timeHour.every(3) ?? d3.timeHour,
    },
    {
      label: "4 hr",
      tickFn: d3.timeHour.every(4) ?? d3.timeHour,
    },
    {
      label: "5 hr",
      tickFn: d3.timeHour.every(5) ?? d3.timeHour,
    },
  ];
  selectedTimelineIndex = this.getDefaultTimelineIndex();


  //
  loading = input<boolean | undefined>();
  @Input() kpiData:any;
  selectedKPIRoutes = input.required<any[]>();
  routeSelectEvent = output<any>();
  deselectAllEvent = output<any>();
  focusDriverMarkerOnMapEvent = output<string>();

  isSorted: boolean | null = null;
  
  currentSortField: string | undefined = undefined;
  currentSortOrder: number = 0; // 1 = asc, -1 = desc, 0 = none
  showItemDetails : boolean = false;

  /**
   * Gantt Collapsed Variables
   */
  isTableCollapsed: boolean = false;
  isGanttHidden: boolean = false;
  isGanttDragged= false;
  ganttSize: number = GANTT_SIZE_DASHBOARD_PAGE;
  btnPosX: string ='calc(60% - 14px)';

  columnList: ColumnPreference[] = [];
  selectedKPIListValue: ColumnPreference = {} as ColumnPreference;
  visibleColumns: any[] = [];
  itemDetailsPopupInfo = {
    title: '',
    itemState: ''
  }
  //Menu item for merge task action.
  menuItems: MenuItem[] = [
    {
      label: 'Merge Task',
      command: () => {
        this.handleMergeTaskClick()
      }
    }];
  selectedRow: any;
  private rafId: number | null = null; //requestAnimationFrame 
  // Observes the Gantt panel so the chart is redrawn (debounced) to fill the
  // section whenever its width changes (split-screen drag, window resize).
  private panelResizeObserver: ResizeObserver | null = null;
  private panelResizeTimer: ReturnType<typeof setTimeout> | null = null;
  private lastPanelWidth = 0;
  private lastSearchQuery = "";
  private lastKpiDataRef: any[] | null = null;
  private lastSearchFiltered: any[] = [];
  private readonly searchKeyCache = new WeakMap<object, string>();
  routePage: string;
  navigation = Navigation;

  ganttLegends: ColorLegend[] = [
    { label: 'Loading', color: GANTT_LEGEND_COLORS.loading },
    { label: 'Prepared Route', color: GANTT_LEGEND_COLORS.preparedRoute },
    { label: 'Yet to deliver', color: GANTT_LEGEND_COLORS.yetToDeliver},
    { label: 'Completed', color: GANTT_LEGEND_COLORS.completed },
    { label: 'Failed', color: GANTT_LEGEND_COLORS.failed },
    { label: 'Shift Ending', color: GANTT_LEGEND_COLORS.shiftEnding },
    { label: 'Break Time', color: GANTT_LEGEND_COLORS.breakTime },
  ];



  constructor(
    private readonly dataAccessService: DataAccessService,
    public dataRepositoryService: DataRepositoryService,
    public taskInfoService: TaskInfoService,
    private readonly commonService: CommonService,
    private readonly datePipe: DatePipe,
    private readonly routeConfigurationService: RouteConfigurationService,
    private readonly messageService: MessageService,
    private readonly kpiProgress : KpiProgressPipe,
    private readonly exportToExcelService:ExportToExcelService,
    public columnService: ColumnService,
    private readonly router: Router,
    private readonly kpiColumnService: KPIColumnService,
    private readonly dateFormatPipe: DateFormatPipe,
  ) {
    this.routePage = this.router.url;
    this.selectedTimelineIndex = this.dataAccessService.routeListTimelineIndex ?? this.getDefaultTimelineIndex();
    this.listnerColumnListEffect();
    this.selectedColumnEffect();  
  }

 /**
   * this effect checks list of column preferences created and updates the list.
   */
  listnerColumnListEffect() {
    effect(() => {
      if (this.dataRepositoryService.userColumnPreferencesList().length) {
        const userPrefs = this.dataRepositoryService.userColumnPreferencesList().filter(
          (e) =>
            e.type?.toLowerCase() ===
            ColumnPreferenceTab.KPI.toLowerCase()
        );
        this.columnList = userPrefs;
      }
    });
  }

  /**
    This method is Called by the merge task actionmenu, if date is today
  */
  openMenu(event: Event, rowData: any) {
    if (!rowData?.kpi?.tasks?.total) {
      this.messageService.add({ severity: ErrorType.WARNING, closable: false, summary: '', detail: ErrorMessage.NOTASKONROUTE });
      return;
    }
    this.menuItems = this.menuItems.map(item => ({
      ...item,
      disabled: this.dataRepositoryService.dateOffset !== 0
    }));
    this.selectedRow = rowData;
    this.menu.toggle(event);
  }
  /**
    This method is Called by the merge task action menus
  */
  onMenuItemClick(event: MouseEvent, item: MenuItem) {
    event.preventDefault();
    event.stopPropagation();
    item.command?.({ originalEvent: event, item });
    this.menu.hide();
  }

  /**
   * This effect checks selected list from dropdown and updates the same.
   */
  selectedColumnEffect() {
    effect(() => {
      if (this.dataRepositoryService.tempSelectedUserColumnPreferences() && this.dataRepositoryService.tempSelectedUserColumnPreferences()?.[
            SelectedPreferencesENUM.KPI
          ]) {
        let kpiSelectedPreference:ColumnPreference =
          this.dataRepositoryService.tempSelectedUserColumnPreferences()?.[
            SelectedPreferencesENUM.KPI
          ]??{} as ColumnPreference;
        kpiSelectedPreference.columnList = this.kpiColumnService.getVisibleColumns('KPI', kpiSelectedPreference?.columnList)
        this.selectedKPIListValue = kpiSelectedPreference??this.kpiColumnService.generateDefaultColumnList(ColumnPreferenceTab.KPI);
        this.setColumnVisibility(kpiSelectedPreference);
      }else{
        //set the default column list
        const defaultColumn = this.kpiColumnService.generateDefaultColumnList(ColumnPreferenceTab.KPI);
        this.selectedKPIListValue = defaultColumn;
        this.setColumnVisibility(defaultColumn);
      }
    });
  }

  /**
   * Method has filter subscription
   */
  filterAppliedSubs() {
    this.subscription.push(
      this.dataAccessService.fitlerApplied$.subscribe((data) => {
        this.updatePersistedRouteFilterState();
        if (data) {
          this.clearSearchAndReset();
        }
      })
    );
  }

  /**
   * Method to clear search text and reset table when any filter is applied
   */
  private updatePersistedRouteFilterState(): void {
    const routeNames = this.dataAccessService.filterSelection?.routeNames;
    this.hasPersistedRouteFilter = Array.isArray(routeNames)
      ? routeNames.length > 0
      : !!routeNames?.toString().trim();
  }

  //Components lifecycle hooks

  ngOnInit(): void {
    this.setItemColumnNames();
    this.routeList = [...this.kpiData];
    // set the width of table and gantt based on dashboard
    // this.routePage = this.router.url;
    this.ganttSize = this.router.url === this.navigation.Dashboard ? GANTT_SIZE_DASHBOARD_PAGE : GANTT_SIZE_GANTT_PAGE;
    this.updatePersistedRouteFilterState();
    this.filterAppliedSubs();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.updatePersistedRouteFilterState();
    if (changes['kpiData'] && changes['kpiData'].currentValue) {
      this.routeList = [...changes['kpiData'].currentValue];
      // Reapply sort if active
      this.renderGanttChart();
    }
  }



  /**
   * To filtervalue for search
   * @param event 
   */
  onGlobalFilter(event: any) {
    this.renderGanttChart();
  }

  private getSearchKey(route: any): string {
    if (!route || typeof route !== 'object') return '';

    const cached = this.searchKeyCache.get(route);
    if (cached !== undefined) return cached;

    const vehicleRegNo = route.vehicle?.reg_no ?? '';
    const key = `${route.route_state ?? ''} ${route.route_label ?? ''} ${route.workshift_name ?? ''} ${vehicleRegNo}`
      .toLowerCase();
    this.searchKeyCache.set(route, key);
    return key;
  }

  private getSearchFilteredRoutes(): any[] {
    const data = Array.isArray(this.kpiData) ? this.kpiData : [];
    const query = (this.searchText ?? '').trim().toLowerCase();

    if (!query) {
      this.lastSearchQuery = '';
      this.lastKpiDataRef = data;
      this.lastSearchFiltered = data;
      return data;
    }

    if (this.lastKpiDataRef === data && this.lastSearchQuery === query) {
      return this.lastSearchFiltered;
    }

    const filtered = data.filter((route) => this.getSearchKey(route).includes(query));
    this.lastSearchQuery = query;
    this.lastKpiDataRef = data;
    this.lastSearchFiltered = filtered;
    return filtered;
  }

  ngAfterViewInit() {
    this.placeButtonOnSplitter();
    // Track splitter moves (dragging) with a ResizeObserver
    const ro = new ResizeObserver(() => this.placeButtonOnSplitter());
    ro.observe(this.splitRoot.nativeElement);

    // Redraw the Gantt whenever the panel's own width changes (split drag,
    // collapse, window resize) so the chart always fills the current section.
    this.panelResizeObserver = new ResizeObserver(() => this.onPanelResize());
    this.panelResizeObserver.observe(this.chartContainer.nativeElement);

    const scrollableBody = this.kpiTable.el.nativeElement.querySelector('.p-datatable-scrollable .p-datatable-table-container');
    if (scrollableBody) {
      scrollableBody.addEventListener('scroll', (e: Event) => {
        const scrollTop = (e.target as HTMLElement).scrollTop;
        this.chartContainer.nativeElement.scrollTop = scrollTop;
      });
    }
  }


  /**
   * Method runs on splitter drag start event, updates the value 
   * of requestAnimationFrame w.r.t split's current size
   */
  onSplitDragStart() {
    const tick = () => {
      this.placeButtonOnSplitter();
      this.rafId = requestAnimationFrame(tick);
    };
    if (this.rafId == null) this.rafId = requestAnimationFrame(tick);
  }
  /**
   * Method runs on splitter drag end event, stops the animationFrame check
   * and process the button position on splitter
   */
  onSplitDragEnd(event:any) {
    if (this.rafId != null) {
      cancelAnimationFrame(this.rafId);
      this.rafId = null;
    }
    if(this.isGanttHidden){
      this.isTableCollapsed = false;
      this.isGanttHidden = false;
      this.isGanttDragged = true;
    }
    this.ganttSize = event.sizes[1];
    //if the gantt-size is 0 means the dragger has moved fully towards right
    if(this.ganttSize==0){
      this.toggleTable();
    }
    this.placeButtonOnSplitter();
  }

  
  /**
   * Method takes multiple HTML elements and checks current boundaries of splitter 
   * and dragger and finally calculate the relative position for button.
   */
  placeButtonOnSplitter() {
    const rootEl = this.splitRoot.nativeElement as HTMLElement;
    const gutter = rootEl.querySelector('.as-split-gutter') as HTMLElement;
    const button = document.querySelector('.collapse-toogle') as HTMLElement;

    if (!gutter || !button) return;

    // Compute position relative to split root
    const rootRect = rootEl.getBoundingClientRect();
    const gutterRect = gutter.getBoundingClientRect();

    const left = gutterRect.left - rootRect.left - (button.offsetWidth / 2);
    button.style.left = `${Math.max(0, left) +7}px`;
    this.btnPosX = button.style.left;
  }


  handleColumnListChange($event: {
    selectedList: ColumnPreference;
    tempUpdate?: boolean;
  }) {
    this.visibleColumns = this.kpiColumnService.getVisibleColumns('KPI', $event.selectedList.columnList)
    this.columnService.setUserColumnPreference(
      SelectedPreferencesENUM.KPI,
      $event.selectedList,
      $event?.tempUpdate ?? false
    );
  }

  /**
  * This is helper method method to update table values
  */
  getKPIValue(kpiData: any, col: string) {
    return col.split('.').reduce((acc, key) => acc && acc[key], kpiData);
  }

  /**
   * This is a helper method to update table values
   * @param kpiData - this holds kpiData
   * @param col - the column id whose data need to be updated
   */
  getColumnValue(kpiData: any, col: any) {
    if (col.id === 'kpi.tasks.pickup') {
      return this.getKPIValue(kpiData, col.id) ?? 0;
    } else {
      return this.getKPIValue(kpiData, col.id) ?? '';
    }
  }

  /**
 * This method checks the previous selected list and sets visible columns 
 * @param defaultCol - selected column list
*/
  setColumnVisibility(defaultCol: ColumnPreference) {
    if (this.selectedKPIListValue) {
      this.visibleColumns =  this.kpiColumnService.getVisibleColumns('KPI', defaultCol.columnList).filter(x => x.enable)
    } else {
      const columns: ColumnPreference =
        this.columnList
          .find((f) => f.id === defaultCol?.id) ?? {} as ColumnPreference;
      this.visibleColumns =  this.kpiColumnService.getVisibleColumns('KPI', columns?.columnList).filter(x => x.enable)
    }
  }
  
  

  onKPISort(event: SortEvent) {
    this.currentSortField = event.field;
    this.currentSortOrder = event.order??0;
    this.sortTableData();
    this.reorderGanttChart();
  }


  reorderGanttChart() {
    const routeSpacing = this.rowHeight;
    const table = d3.select(this.chartContainer.nativeElement).select('svg').select('.gantt');
    table
      .selectAll<SVGGElement, any>('.route-row')
      .data(this.routeList, (d: any) => d.route_id)
      .transition()
      .duration(300)
      .attr("transform", (d, i) => `translate(0, ${i * routeSpacing})`);
  }

  /**
  * This method helps to toggle KPI table expand collapse functionality
  */
  toggleTable() {
    this.isTableCollapsed = !this.isTableCollapsed;
    if(this.isTableCollapsed){
      this.isGanttHidden = true;
      this.isGanttDragged = false;
    }
    else{
      this.ganttSize = this.router.url === this.navigation.Dashboard ? GANTT_SIZE_DASHBOARD_PAGE : GANTT_SIZE_GANTT_PAGE;
    }
  }

  /**
   * Sorts the routeList array based on the current sort field and order.
   * Handles nulls and compares strings and other types appropriately.
  */
  sortTableData() {
    if (this.routeList.length && this.currentSortField && this.currentSortOrder !== 0) {
      this.routeList.sort((a:any, b:any) => {
      const val1 = this.resolveFieldData(a, this.currentSortField??'');
      const val2 = this.resolveFieldData(b, this.currentSortField??'');

      let result = 0;

      if (val1 == null && val2 != null) result = -1;
      else if (val1 != null && val2 == null) result = 1;
      else if (val1 == null && val2 == null) result = 0;
      else if (typeof val1 === 'string' && typeof val2 === 'string') {
        result = val1.localeCompare(val2);
      } else {
        result = val1 < val2 ? -1 : val1 > val2 ? 1 : 0;
      }

        return this.currentSortOrder * result;
      });
    }
  }

  /**
   * Safely retrieves nested field value from an object using dot notation.
   * Returns null if any property in the path is missing.
   * 
   * @param data The object to retrieve the value from.
   * @param field The field name or path (e.g., "kpi.items").
 */
  resolveFieldData(data: any, field: string): any {
    if (!data || !field) return null;
    if (field.indexOf('.') === -1) return data[field];

    return field.split('.').reduce((obj, key) => (obj ? obj[key] : null), data);
  }

  setItemColumnNames() {
    this.itemColumnNames = [
      { field: "task_sequence", header: "Task Sequence" },
      { field: "receivername", header: "Receiver Name" },
      { field: "address", header: "Address" },
      { field: "pn_item_id", header: "Barcode" },
      { field: "eta", header: "ETA" },
      { field: "ata", header: "ATA" },
      { field: "task_time_window", header: "Time Window" },
      { field: "itemState", header: "Item State" },
      { field: "product_code", header: "Product Code" },
    ];
  }

  /**
   * Eligible routes can be marked as complete with confirmation alert 
   * @param route route details
   */
  markRouteComplete(route: Routes) {
    this.commonService.showConfirmationAlert(AppConstants.COMPLETE_ROUTE, AppConstants.COMPLETE_CONFIRMATION, () => {
      this.routeConfigurationService.markRouteComplete(route).pipe(take(1)).subscribe({
        next: () => {
          this.messageService.add({ severity: ErrorType.SUCCESS, closable: false, summary: '', detail: ErrorMessage.ROUTESTATEUPDATEMESSAGE });
          this.dataAccessService.getRouteInfoDeltaOnce();
        },
        error: (error) => {
          if (error.status === HttpStatusCode.Forbidden) {
            this.messageService.add({ severity: ErrorType.ERROR, closable: false, summary: '', detail: ErrorMessage.RESTRICTIONMESSAGE });
          } else {
            this.messageService.add({ severity: ErrorType.ERROR, closable: false, summary: '', detail: ErrorMessage.ROUTESTATEUPDATEERRORMESSAGE });
          }
        }
      });
    });
  }

  /**
   * Handles the p-table selectionChange event for route selection.
   * @param event - Full selection array emitted by PrimeNG selectionChange
   */
  routeSelect(event: any) {
    this.routeSelectEvent.emit(event || []);
  }

  deselectAll() {
    this.deselectAllEvent.emit(null)
  }

  focusDriverMarkerOnMap(routeId: string) {
    this.focusDriverMarkerOnMapEvent.emit(routeId);
  }
  //


  //Public Methods

  fullScreen(fs: boolean) {
    this.isFullScreen = fs;
    this.sectionFullScreen.emit(fs);
  }

  openRouteDetails(roteInfoItem: any) {
    sessionStorage.setItem("route_Id", roteInfoItem.route_id);
    window.open("#/routeinfo", "_blank");
  }

  scrollToTop() {
    if (this.kpiTable) {
      this.kpiTable.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
  }

  openRouteItemDetailsPopup(kpiData: Routes) {
    if (kpiData?.route_state.toLowerCase() === RouteState.Loading) {
      this.showItemDetails = !this.showItemDetails;
      this.routesDetails = kpiData;
      this.itemDetailsPopupInfo = {
        title:'Not Loaded Items',
        itemState: ItemState.Planned
      }
    }
  }

  @HostListener("window:resize", ["$event"])
  onResize(event: Event) {
    // The panel is percentage-based, so a window resize changes its width and the
    // ResizeObserver already handles it; go through the same debounced redraw so
    // overlapping resize events rebuild the chart only once.
    this.scheduleGanttRedraw();
  }

  ngOnDestroy() {
    this.panelResizeObserver?.disconnect();
    this.panelResizeObserver = null;
    if (this.panelResizeTimer != null) {
      clearTimeout(this.panelResizeTimer);
      this.panelResizeTimer = null;
    }
  }

  /**
   * Redraw the Gantt when the panel width settles after a resize or split-drag.
   * The redraw is debounced so a continuous drag rebuilds the chart once (at the
   * end) instead of on every frame, and height-only changes (row count) are
   * ignored.
   */
  private onPanelResize() {
    const width = this.chartContainer?.nativeElement?.clientWidth ?? 0;
    if (width <= 0 || Math.abs(width - this.lastPanelWidth) < 1) {
      return;
    }
    this.lastPanelWidth = width;
    this.scheduleGanttRedraw();
  }

  /**
   * Debounced full redraw of the Gantt. Shared by the panel ResizeObserver and
   * the window resize handler so overlapping events rebuild the chart only once.
   */
  private scheduleGanttRedraw() {
    if (this.panelResizeTimer != null) {
      clearTimeout(this.panelResizeTimer);
    }
    this.panelResizeTimer = setTimeout(() => {
      this.panelResizeTimer = null;
      this.removeChart();
      this.calculateDimension();
      this.createGanttChart();
    }, 150);
  }

  /**
   * Returns true when the timeline can move to a wider window.
   */
  get canIncrease(): boolean {
    return this.selectedTimelineIndex < this.timelineLevels.length - 1;
  }

  /**
   * Returns true when the timeline can move to a narrower window.
   */
  get canDecrease(): boolean {
    return this.selectedTimelineIndex > 0;
  }

  /**
   * Returns the currently selected timeline label for the stepper.
   */
  get selectedTimelineLabel(): string {
    return this.timelineLevels[this.selectedTimelineIndex]?.label ?? this.timelineLevels[this.getDefaultTimelineIndex()].label;
  }

  /**
   * Zooms the gantt timeline out by moving to the next coarser level.
   */
  increaseTimeline() {
    if (!this.canIncrease) {
      return;
    }
    this.selectedTimelineIndex += 1;
    // Persist the selection so dashboard and gantt reuse the same zoom level.
    this.dataAccessService.routeListTimelineIndex = this.selectedTimelineIndex;
    this.removeChart();
    this.calculateDimension();
    this.createGanttChart();
  }

  /**
   * Zooms the gantt timeline in by moving to the next finer level.
   */
  decreaseTimeline() {
    if (!this.canDecrease) {
      return;
    }
    this.selectedTimelineIndex -= 1;
    // Persist the selection so dashboard and gantt reuse the same zoom level.
    this.dataAccessService.routeListTimelineIndex = this.selectedTimelineIndex;
    this.removeChart();
    this.calculateDimension();
    this.createGanttChart();
    // Re-measure after paint in case the resize changed the device-pixel-ratio
    // (e.g. moving the window between a HiDPI and a standard monitor).
    this.syncGanttToTableRowHeight();
  }

  @HostListener("scroll", ["$event"])
  onScroll(event: any) {
    this.GanttHeaderElement.nativeElement.scrollLeft = event.target.scrollLeft;
    const scrollTop = (event.target as HTMLElement).scrollTop;
    const scrollableBody  = this.routeTable.nativeElement.querySelector('.p-datatable-table-container');
    scrollableBody.scrollTop = scrollTop;
  }

  removeChart() {
    const element = this.chartContainer?.nativeElement;
    const ganttHeader = this.GanttHeaderElement?.nativeElement;
    if (element) {
      d3.select(element).select("svg").remove();
    }
    if (ganttHeader) {
      d3.select(ganttHeader).select("svg").remove();
    }
    if (this.currentTimeInterval) {
      clearInterval(this.currentTimeInterval);
      this.currentTimeInterval = 0;
    }
  }

  /**
   * Calculate Dimensions of the chart
   */
  calculateDimension() {
    if (!this.routeList.length) {
      this.routeList = [];
    } 
    const viewType = this.isSelectionEnable ? 'unifiedView' : 'ganttView'
    const hasRoutes = this.routeList.length > 0;
    // Available drawing width: prefer the panel's real rendered width so the gantt
    // tracks split-screen drags and window resizes; fall back to a window-derived
    // width before the panel is laid out or when there are no routes.
    const panelWidth = this.chartContainer?.nativeElement?.clientWidth ?? 0;
    const availableWidth = hasRoutes && panelWidth > 0 ? panelWidth : this.getFallbackWidth();
    if (hasRoutes) {
      // Never narrower than the panel (coarse levels fill it); grow so every tick
      // gets a minimum width (fine levels scroll and stay readable).
      this.width = Math.max(1, Math.round(Math.max(availableWidth, this.getZoomWidth())));
    } else if (this.routePage === this.navigation.Gantt) {
      this.width = Math.max(1, Math.round(availableWidth));
    } else {
      this.width = Math.max(1, Math.min(Math.round(availableWidth), 700));
    }
    const measuredRowHeight = this.measureTableRowHeight();
    if (measuredRowHeight > 0) {
      this.rowHeight = measuredRowHeight;
    }
    const totalRoutes = this.routeList.length ?? 0; // Replace with the actual number of routes
    const dynamicHeight =
      totalRoutes * this.rowHeight + this.margin.top + this.margin.bottom;
    this.height = dynamicHeight - 42;
  }

  /**
   * Measure the actual rendered height of a route table row so the Gantt row
   * spacing can match it exactly. This avoids the cumulative vertical drift a
   * hardcoded row height causes, since display scaling can render rows at a
   * fractional height (e.g. 25.5px) on large/HiDPI screens.
   * Returns 0 when no row has been rendered yet.
   */
  measureTableRowHeight(): number {
    const firstRow: HTMLElement | null | undefined =
      this.routeTable?.nativeElement?.querySelector('.p-datatable-tbody > tr');
    return firstRow?.getBoundingClientRect().height ?? 0;
  }

  
  /**
   * Width to fall back to before the gantt panel has a rendered width (first
   * paint) or when there are no routes. Derived from the window width minus a
   * fixed offset for the current view type and collapsed/expanded state.
   */
  private getFallbackWidth(): number {
    const viewType = this.isSelectionEnable ? 'unifiedView' : 'ganttView';
    const screenWidth = this.routeList.length ? window.innerWidth : 1000;
    const size =
      screenWidth > BREAKPOINT_LARGE ? 'large'
        : screenWidth > BREAKPOINT_MEDIUM ? 'medium'
          : 'small';
    const { collapsed, expanded } = OFFSETS[viewType][size];
    return screenWidth - (this.isTableCollapsed ? collapsed : expanded);
  }

  /**
   * Minimum drawing width needed for the selected timeline so every tick gets at
   * least MIN_PX_PER_TICK of horizontal space (keeps fine levels legible).
   */
  private getZoomWidth(): number {
    const level =
      this.timelineLevels[this.selectedTimelineIndex] ??
      this.timelineLevels[this.getDefaultTimelineIndex()];
    const tickCount = (level.tickFn as d3.TimeInterval)
      .range(this.getDate(DateType.begin), this.getDate(DateType.end)).length;
    return tickCount * MIN_PX_PER_TICK;
  }
  /**
   * Plott the chart
   */
  createGanttChart() {
    let element = this.chartContainer?.nativeElement;
    let ganttHeader = this.GanttHeaderElement?.nativeElement;
    if(element && ganttHeader) {
      const chartWidth = this.width + 40;
      const headerSVG: any = d3
      .select(ganttHeader)
      .append("svg")
      .attr(
        "width",
        chartWidth
      )
      .attr("height", 40);

    const svg: any = d3
      .select(element)
      .append("svg")
      .attr(
        "width",
        chartWidth
      )
      .attr(
        "height",
        this.routeList.length ? this.height : window.innerHeight - 150
      );
      this.createProgressBar(svg, headerSVG);
    }
  }

  /**
   *
   * @param svg
   */
  createProgressBar(svg: any, headerSVG: any) {
    const timeFormat = this.formatTime();
    this.noRecords = false;
    if (this.routeList.length) {
      this.x = d3
        .scaleTime()
        .domain([this.getDate(DateType.begin), this.getDate(DateType.end)])
        .range([0, this.width]);

      const ticksDuration =
        this.timelineLevels[this.selectedTimelineIndex]?.tickFn ??
        this.timelineLevels[this.getDefaultTimelineIndex()].tickFn;

      const xAxis: any = d3
        .axisTop(this.x)
        .ticks(ticksDuration as d3.CountableTimeInterval)
        .tickFormat(timeFormat)
        .tickPadding(12);

      this.createHeader(headerSVG, xAxis);
      this.drawVerticalGrid(svg, this.x, this.height)
      const routeSpacing = this.rowHeight;
      const barHeight = 15;

      // Append a group element for the table-like structure
      const table = svg
        .append("g")
        .attr("class", "gantt")
        .attr(
          "transform",
          "translate(" + this.margin.left + "," + -20 + ")"
        );

      // Append rows for each route
      const rows = table
        .selectAll(".route-row")
        .data(this.routeList, (d:any) => d.route_id)
        .enter()
        .append("g")
        .attr("class", "route-row")
        .attr(
          "transform",
          (d: any, i: number) => "translate(0," + i * routeSpacing + ")"
        );

      // Append bars for each route
      this.appendBarForRoute(rows, barHeight, svg);

      // Append lines after each bar
      this.appendLineBelowRouteBar(rows, barHeight);
      // Append Delivered and Failed Bar
      this.appendDeliverFailedBar(rows, barHeight);

      // Append loading period bar
      this.appendLoadingTimeBar(rows, barHeight);

      this.appendBreakTaskBar(rows,barHeight)
      // Append prepare-route period bar
      this.appendPrepRouteTimeBar(rows, barHeight);
      
      this.appendFailedBar(rows, barHeight);

      // Append text for each route's delivered items
      this.appendDeliveredNo(rows, barHeight);

      // Append text for each route's planned items
      this.appendPlannedNo(rows, barHeight);

      this.drawCurrentTimeLine(svg, headerSVG);

    } else {
      this.plottGanttNoRecords(headerSVG, svg);
    }
  }

  /**
   * To append Delivered and Failed Progress Bar Based upon the
   * completed and failed items
   * @param rows To append row for each route
   * @param barHeight height of the bar
   */
  appendDeliverFailedBar(rows: any, barHeight: number) {
    const barX = (d: any) => {
      const startTime = this.handleStartTimeTimeline(
        this.commonService.dateFormatter(d.route_time_window.begin)
      );
      return this.x(startTime);
    };

    rows
      .append("rect")
      .attr("class", "delivered-bar")
      .attr("x", (d: any) => barX(d))
      .attr("y", 18)
      .attr("width", (d: any) =>
        this.getBarWidth(d, ItemState.Delivered.toLowerCase()) > 0? this.getBarWidth(d, ItemState.Delivered.toLowerCase()) : 0
      )
      .attr("height", barHeight)
      .style("fill", "#2EBE39");
  }

  /**
   * To append failed Task over the bar
   * @param rows  To append row for each route
   * @param barHeight height of the bar
   */
  appendFailedBar(rows: any, barHeight: number) {
    rows
      .selectAll(".failed-item-bar")
      .data((routeData: any) => {
        const failed_tasks = routeData.failed_tasks;
        failed_tasks.sort(
          (a: any, b: any) =>
            new Date(a.task_failed_time).getTime() -
            new Date(b.task_failed_time).getTime()
        );
        return failed_tasks.map((item: any) => ({ ...item, routeData }));
      })
      .enter()
      .append("rect")
      .attr("x", (d: any, i: number, failedTasks: any[]) => {
        const xPosition = this.x(
          this.commonService.dateFormatter(d.task_failed_time)
        );
        return xPosition;
      })
      .attr("y", 18)
      .attr("width", 2.5)
      .attr("height", barHeight)
      .style("stroke-width", "0.3px")
      .on("mouseover", function (this: SVGRectElement, event: MouseEvent) {
        d3.select(this)
          .raise()
          .transition()
          .duration(100)
          .attr("y", 12)
          .attr("height", barHeight + 15)
          .attr("width", 10)
          .style("stroke-width", "1px")
          .style("stroke", "#000")
          .style("filter", "brightness(1.2)");
      })
      .on("mouseout", function (this: SVGRectElement, event: MouseEvent) {
        d3.select(this)
          .transition()
          .duration(100)
          .attr("y", 18)
          .attr("height", barHeight)
          .attr("width", 2.5)
          .style("stroke-width", "0.3px")
          .style("stroke", "#fff")
          .style("filter", "brightness(1)");
      })
      .style("stroke", "#fff")
      .style("fill", "#F04B5E")
      .on("click", (event: MouseEvent, d: any) => {
        this.showFailedItems(d?.routeData);
        this.taskid = d?.task_id;
      });
  }

  appendBreakTaskBar(rows: any, barHeight: number) {

    rows
      .each((route: any, i: number, nodes: any[]) => {

        if (!route.break_time_window?.length) {
          return;
        }

        d3.select(nodes[i])
          .selectAll(".break-bar")
          .data(route.break_time_window)
          .enter()
          .append("rect")
          .attr("class", "break-bar")
          .attr("x", (tw: any) => {
            const start = this.commonService.dateFormatter(tw.begin);
            return this.x(start);
          })
          .attr("y", 18)
          .attr("width", (tw: any) => {
            const start = this.commonService.dateFormatter(tw.begin);
            const end = this.commonService.dateFormatter(tw.end);
            return Math.max(this.x(end) - this.x(start), 2);
          })
          .attr("height", barHeight)
          .style("fill", "#CACACA");
      });
  }
 
  /**
   * To append the loading period bar based on the route state as loading and post loading
   * @param rows to append row for each route
   * @param barHeight height of the bar
   */
  appendLoadingTimeBar(rows: any, barHeight: number) {
    const barX = (d: any) => {
      const loading_ts = this.commonService.dateFormatter(d.loading_ts)
      return this.x(loading_ts);
    };
    rows
      .append("rect")
      .attr("class", "delivered-bar")
      .attr("x", (d: any) => barX(d))
      .attr("y", 18)
      .attr("width", (d: any) => {
        const width = this.getLoadingBarWidth(d);
        return width > 0 ? width : 0;
      })
      .attr("height", barHeight)
      .style("fill", "#836EDD")

      .on("mouseover", (event: MouseEvent, d: any) => {
        const startTime = this.dateFormatPipe.transform(
          d.loading_ts,
          DateFormatType.DATETIME
        );
        const endTime =
          d.route_state.toLowerCase() === RouteState.Loading.toLowerCase()
            ? this.dateFormatPipe.transform(
                d?.route_time_window?.begin,
                DateFormatType.DATETIME
              )
            : this.dateFormatPipe.transform(
                d?.finishloading_ts,
                DateFormatType.DATETIME
              );
        this.tooltip.style("opacity", "1").html(`
              <div>Loading start time: <b>${startTime}</b></div>
              <div>Loading end time: <b>${endTime}</b></div>
            `);
      })
      .on("mousemove", (event: MouseEvent) => {
        // Position near the cursor with some offset
        const offset = 12;
        this.tooltip
          .style("left", `${event.pageX + offset}px`)
          .style("top", `${event.pageY + offset}px`);
      })
      .on("mouseout", () => {
        this.tooltip.style("opacity", "0");
      });

  }

  /**
   * To append the prepare route period bar based on the route state 
   * @param rows to append row for each route
   * @param barHeight height of the bar
   */
  appendPrepRouteTimeBar(rows: any, barHeight: number) {
    const barX = (d: any) => {
      const finishLoading_ts = this.commonService.dateFormatter(d.finishloading_ts)
      return this.x(finishLoading_ts);
    };

    rows
      .append("rect")
      .attr("class", "delivered-bar")
      .attr("x", (d: any) => barX(d))
      .attr("y", 18)
      .attr("width", (d: any) => {
        const width = this.getPrepRouteBarWidth(d);
        return width > 0 ? width : 0;
      })
      .attr("height", barHeight)
      .style("fill", "#4C1DB5")
      .on("mouseover", (event: MouseEvent, d: any) => {
        const startTime = this.dateFormatPipe.transform(
          d.finishloading_ts,
          DateFormatType.DATETIME
        );
        const endTime =
          d.route_state.toLowerCase() === RouteState.Finishloading.toLowerCase()
            ? this.dateFormatPipe.transform(
                d?.route_time_window?.begin,
                DateFormatType.DATETIME
              )
            : this.dateFormatPipe.transform(
                d?.onroute_ts,
                DateFormatType.DATETIME
              );
        this.tooltip.style("opacity", "1").html(`
              <div>Prepare Route Start Time: <b>${startTime}</b></div>
              <div>Prepare Route End Time: <b>${endTime}</b></div>
            `);
      })
      .on("mousemove", (event: MouseEvent) => {
        // Position near the cursor with some offset
        const offset = 12;
        this.tooltip
          .style("left", `${event.pageX + offset}px`)
          .style("top", `${event.pageY + offset}px`);
      })
      .on("mouseout", () => {
        this.tooltip.style("opacity", "0");
      });
  }

  plottGanttNoRecords(headerSVG: any, svg: any) {
    // Mark the empty state so the stepper stays visible but disabled.
    this.noRecords = true;
    const timeFormat = this.formatTime();
    const currentDay = this.getDateWithOffset();
    const formatDate = this.datePipe.transform(currentDay, "MM/dd/yyyy");
    const data = [...this.dataRepositoryService.kpiDataMap.values()];
    this.x = d3
      .scaleTime()
      .domain([
        new Date(`${formatDate} 08:00 AM`),
        new Date(`${formatDate} 10:00 PM`),
      ])
      .range([0, this.width]);

    const xAxis: any = d3
      .axisTop(this.x)
      .ticks(d3.timeHour.every(2))
      .tickFormat(timeFormat)
      .tickPadding(12);

    // Create Header
    this.createHeader(headerSVG, xAxis);
    if (!data.length) {
      const row = svg
        .append("g")
        .attr("class", "gantt")
        .attr(
          "transform",
          "translate(" + this.margin.left + "," + this.margin.top + ")"
        );
      //No Records Text
      row
        .append("text")
        .text("No Records Found")
        .attr("y", -10)
        .attr("height", 50)
        .style("font-family", "StagSansApp-Light , sans-serif")
        .style("font-weight", "600")
        .style("font-size", "20px");
    }
  }
  formatTime() {
    const d3TimeFormat = d3.timeFormat("%H:%M");
    return (value: any, index: number) => {
      const firstValue = index === 0;
      return value.getHours() === 0 && !firstValue
        ? "24:00"
        : d3TimeFormat(value);
    };
  }
  /**
   * To get selected Date based upon the Offset
   * @returns current selected date in datepicker
   */
  getDateWithOffset() {
    const today: Date = this.commonService.dateFormatter(new Date());
    const targetDate: Date = this.commonService.dateFormatter(today);
    targetDate.setDate(targetDate.getDate() + this.dataRepositoryService.dateOffset);
    return targetDate;
  }

  /**
   *
   * @param type | Beign || End Date
   * @returns Begin and End Date for the Timeline
   * Based upon the selected Offset
   */
  getDate(type: any): any {
    const CurrentSelectedDate = this.getDateWithOffset();
    const data = this.routeList;
    const minDateRouteListTodaysDate = data.filter(
      (x: any) =>
        this.commonService
          .dateFormatter(x.route_time_window.begin)
          .toDateString() === CurrentSelectedDate.toDateString()
    );
    const maxDateRouteListTodaysDate = data;

    if (type === DateType.begin) {
      const minDateList = minDateRouteListTodaysDate.map((x: any) =>
        this.commonService.dateFormatter(x.route_time_window.begin)
      );
      let minDate: any = this.commonService.getMinMaxDate(minDateList, "min");
      minDate.setMinutes(minDate.getMinutes() - 30);
      this.minDate = minDate;
      return this.minDate;
    }

    if (type === DateType.end) {
      const maxDateList = maxDateRouteListTodaysDate.map((x: any) =>
        this.commonService.dateFormatter(x.route_time_window.end)
      );
      this.maxDate = this.commonService.getMinMaxDate(maxDateList, "max");
      if (this.maxDate?.toDateString() === CurrentSelectedDate.toDateString()) {
        this.maxDate = new Date(this.maxDate.getTime() + 60 * 60 * 1 * 1000); // To add 1 Hour if the max time isn't beyond today's date
      } else {
        this.maxDate = new Date(this.minDate.getTime() + 60 * 60 * 24 * 1000); // To add 24 Hour if the max time is beyound today' date
      }
      return this.maxDate;
    }
  }

  createHeader(headerSVG: any, xAxis: any) {
    headerSVG
      .append("g")
      .attr("class", "x-timeline-axis")
      .attr(
        "transform",
        "translate(" + this.margin.left + "," + this.margin.top + ")"
      )
      .style("stroke-width", 0.5)
      .style("font-size", "10px")
      .style("font-family", "StagSansApp-Book , sans-serif")
      .style("stroke", "#6E788D")
      .call(xAxis);
    
  }

  appendBarForRoute(rows: any, barHeight: any, svg: any) {
    rows
      .append("rect")
      .attr("class", "route-bar")
      .attr("x", (d: any) => {
        const startTime = this.handleStartTimeTimeline(
          this.commonService.dateFormatter(d?.route_time_window?.begin)
        );
        return this.x(startTime);
      })
      .attr("y", 18)
      .attr("width", (d: any) => {
        const endTime = this.handleEndTimeBeyondTimeline(
          this.commonService.dateFormatter(d?.route_time_window?.end)
        );
        const startTime = this.handleStartTimeTimeline(
          this.commonService.dateFormatter(d?.route_time_window?.begin)
        );
        const difference =
          (endTime.getTime() - startTime.getTime()) / (1000 * 60);
        if (difference < 45) {
          return "100px";
        }
        return this.x(endTime) - this.x(startTime);
      })
      .attr("height", barHeight)
      .attr("fill", "#42A8DE")
      .style("filter", "url(#drop-shadow)"); // Apply drop shadow filter

    // Stripes pattern
    svg
      .append("defs")
      .append("pattern")
      .attr("id", "striped-pattern")
      .attr("width", "8")
      .attr("height", "8")
      .attr("patternUnits", "userSpaceOnUse")
      .attr("patternTransform", "rotate(-45)")
      .append("rect")
      .attr("width", "4")
      .attr("height", "8")
      .attr("transform", "translate(0,0)")
      .attr("fill", "white")
      .style("opacity", 0.4);

    // Beyond TimeLine Bar
    rows
      .append("rect")
      .attr("class", "route-bar-beyond-window-timeline")
      .attr("x", (d: any) => this.x(this.maxDate))
      .attr("y", 18)
      .attr("width", (d: any) => {
        const endTime = this.commonService.dateFormatter(
          d.route_time_window.end
        );
        if (endTime > this.maxDate) {
          return "30px";
        } else {
          return "0px";
        }
      })
      .attr("height", barHeight)
      .attr("fill", "#9B1C2E")
      .attr("rx", 5)
      .attr("ry", 5);

    rows
      .append("rect")
      .attr("x", (d: any) => this.x(this.maxDate))
      .attr("y", 18)
      .attr("width", (d: any) => {
        const endTime = this.commonService.dateFormatter(
          d.route_time_window.end
        );
        if (endTime > this.maxDate) {
          return "30px";
        } else {
          return "0px";
        }
      })
      .attr("height", barHeight)
      .attr("rx", 5)
      .attr("ry", 5)
      .style("fill", "url(#striped-pattern)"); // Apply drop shadow filter
    // Append the drop shadow filter
    svg
      .append("defs")
      .append("filter")
      .attr("id", "drop-shadow")
      .attr("height", "150%")
      .append("feDropShadow")
      .attr("dx", 0)
      .attr("dy", 2)
      .attr("stdDeviation", 2)
      .attr("flood-color", "rgba(0, 0, 0, 0.4)"); // Adjust the shadow properties as needed
  }

  appendLineBelowRouteBar(rows: any, barHeight: any) {
    rows
      .append("line")
      .attr("class", "separator-line")
      .attr("x1", this.x(this.getDate(DateType.begin))) // Start position of the line
      .attr("y1", barHeight + 23) // Y position at the bottom of the bar
      .attr("x2", this.x(this.getDate(DateType.end))) // End position of the line
      .attr("y2", barHeight + 23) // Y position at the bottom of the bar
      .attr("stroke", "#6E788D")
      .attr("stroke-width", 0.5);
  }

  appendDeliveredNo(rows: any, barHeight: any) {
    rows
      .append("text")
      .attr("class", "delivered")
      .attr("x", (d: any) => {
        const startTime = this.handleStartTimeTimeline(
          this.commonService.dateFormatter(d.route_time_window.begin)
        );
        return (
          this.x(startTime) +
          this.getBarWidth(d, ItemState.Delivered.toLowerCase()) +
          5
        );
      })
      .attr("y", barHeight + 13) // Center the text vertically
      .text((d: any) => `${d.kpi.items.delivered}`)
      .style("font-size", "10px")
      .style("font-family", "StagSansApp-Light , sans-serif")
      .style("font-weight", "600")
      .style("fill", "#04da39")
      .style("cursor", "pointer")
      .on("click", (e: any, d: any) => this.showDeliveredItems(d));
  }

  appendPlannedNo(rows: any, barHeight: any) {
    rows
      .append("text")
      .attr("class", "planned")
      .attr("x", (d: any) => {
        const startTime = this.handleStartTimeTimeline(
          this.commonService.dateFormatter(d.route_time_window.begin)
        );
        const deliveredWidth = this.getBarWidth(
          d,
          ItemState.Delivered.toLowerCase()
        );
        const plannedWidth = this.getBarWidth(
          d,
          ItemState.Planned.toLowerCase()
        );
        const loadedWidth = this.getBarWidth(d, ItemState.Loaded.toLowerCase());
        const totalWidth = deliveredWidth + plannedWidth + loadedWidth;
        return this.x(startTime) + totalWidth - 25;
      })
      .attr("y", barHeight + 13) // Center the text vertically
      .text((d: any) => `${d.kpi.items.planned + d.kpi.items.loaded}`)
      .style("font-size", "10px")
      .style("font-family", "StagSansApp-Light , sans-serif")
      .style("font-weight", "600")
      .style("fill", "#fff")
      .style("cursor", "pointer")
      .on("click", (e: any, d: any) => this.showPlannedItems(d));
  }

  /**
   * To get the Bar width Based upon the
   * Item Type | Deliver | Failed-attempt
   * @param route Route Object | Contains information of the route
   * @param type item Type (FailedAttempt|Deliver) for which we need the bar width
   * @returns Returns width of the bar based upon the item type
   */
  getBarWidth(route: any, type: string) {
    // Subsctracting failed items from total in order to
    // Fill the progres bar for Delivered Items.
    const total = route.kpi.items.total - route.kpi.items.failedattempt;
    if (total === 0) return 0;
    const endTime = this.handleEndTimeBeyondTimeline(
      this.commonService.dateFormatter(route.route_time_window.end)
    );
    const startTime = this.handleStartTimeTimeline(
      this.commonService.dateFormatter(route.route_time_window.begin)
    );
    // Parameter to store the difference of route end time and start Time
    let routeDuration;
    const difference = (endTime.getTime() - startTime.getTime()) / (1000 * 60);
    if (difference < 45) {
      routeDuration = 100; //static time for the timeline which are less than 45min
    } else {
      routeDuration = this.x(endTime) - this.x(startTime);
    }
    let count = route.kpi.items[type];
    return (count / total) * routeDuration;
  }

  /**
     * Method calculates the width of the Loading period bar based on route state
     * @param route Route object
     * @returns the calculated width of the bar
     */
  getLoadingBarWidth(route: any) {
    // Subsctracting failed items from total in order to
    // Fill the progres bar for Delivered Items.
    const total = route.kpi.items.total - route.kpi.items.failedattempt;
    /**
     * To handle the case where loading_ts coming null
     * Sometime directly move to prepare route using app when route is create
     * from WSP
     */
    if (total === 0 || 
      route.loading_ts === null
    ) return 0;
    if (route.route_state.toLowerCase() === RouteState.Sorting.toLowerCase()) return 0;

    // get the end time value of the bar as per route state
    // loading state route - route begin time
    // Finish loading/On-route - finishLoading time stamp
    const endTimeValue =
      route.route_state.toLowerCase() === RouteState.Loading.toLowerCase()
        ? route?.route_time_window?.begin
        : route?.finishloading_ts;
    const endTime = this.commonService.dateFormatter(endTimeValue)
    const startTime = this.commonService.dateFormatter(route.loading_ts)
    const routeDuration = this.x(endTime) - this.x(startTime);
    return routeDuration;
  }

  /**
    * Method calculates the width of the prepare route period bar based on route state
    * @param route route object
    * @returns the calculated width of the bar
    */
  getPrepRouteBarWidth(route: any) {
    if (
      route.route_state.toLowerCase() === RouteState.Sorting.toLowerCase() ||
      route.route_state.toLowerCase() === RouteState.Loading.toLowerCase()
    ) {
      return 0;
    }

    // get the end time value of the bar as per route state
    // FinishLoading state route - route begin time
    const endTimeValue =
      route.route_state.toLowerCase() === RouteState.Finishloading.toLowerCase()
        ? route?.route_time_window?.begin
        : route?.onroute_ts;
    const endTime = this.commonService.dateFormatter(endTimeValue)
    const startTime = this.commonService.dateFormatter(route.finishloading_ts)
    // Parameter to store the difference of route end time and start Time
    let routeDuration = this.x(endTime) - this.x(startTime);
    return routeDuration;
  }

  /**
   *
   * @param routeStartTime
   * @returns  Return Start Time based on if the route end time window
   * is going today - 1
   */
  handleStartTimeTimeline(routeStartTime: any) {
    if (!routeStartTime || Number.isNaN(new Date(routeStartTime).getTime())) {
      return this.minDate;
    }
    const CurrentSelectedDate = this.getDateWithOffset();
    if (routeStartTime.toDateString() === CurrentSelectedDate.toDateString()) {
      return routeStartTime;
    } else {
      return this.minDate;
    }
  }

  /**
   * To open popup for the Delivered Items
   * @param routesDetails  Select Route Details
   */
  showDeliveredItems(routesDetails: any) {
    this.itemColumnNames = [
      { field: "task_sequence", header: "Task Sequence" },
      { field: "receivername", header: "Receiver Name" },
      { field: "address", header: "Address" },
      { field: "pn_item_id", header: "Barcode" },
      { field: "eta", header: "ETA" },
      { field: "ata", header: "ATA" },
      { field: "task_time_window", header: "Time Window" },
      { field: "itemState", header: "Item State" },
      { field: "product_code", header: "Product Code" },
      { field: "reasoncode", header: "Reason Code" },
      { field: "gttEvent", header: "GTT Event" },
      { field: "eventcode", header: "Event Code" },
      { field: "photo_delivery_flow", header: "DIA" },
    ];
    this.showItemDetails = true;
    this.routesDetails = routesDetails;
    this.itemDetailsPopupInfo = {
      title : 'Delivered Items',
      itemState: ItemState.Delivered
    }
  }

  /**
   * To open popup for the Planned Items
   * @param routesDetails  Select Route Details
   */
  showPlannedItems(routesDetails: any) {
    this.itemColumnNames = [
      { field: "task_sequence", header: "Task Sequence" },
      { field: "receivername", header: "Receiver Name" },
      { field: "address", header: "Address" },
      { field: "pn_item_id", header: "Barcode" },
      { field: "eta", header: "ETA" },
      { field: "ata", header: "ATA" },
      { field: "task_time_window", header: "Time Window" },
      { field: "itemState", header: "Item State" },
      { field: "product_code", header: "Product Code" },
    ];
    this.showItemDetails = true;
    this.routesDetails = routesDetails;
    this.itemDetailsPopupInfo = {
      title : 'Yet to Deliver Items',
      itemState: ItemState.YetToBeDelivered
    }
  }

  /**
   * To open popup for the Failed Items
   * @param routesDetails  Select Route Details
   */
  showFailedItems(routesDetails: any) {
    this.itemColumnNames = [
      { field: "task_sequence", header: "Task Sequence" },
      { field: "receivername", header: "Receiver Name" },
      { field: "address", header: "Address" },
      { field: "pn_item_id", header: "Barcode" },
      { field: "eta", header: "ETA" },
      { field: "ata", header: "ATA" },
      { field: "task_time_window", header: "Time Window" },
      { field: "itemState", header: "Item State" },
      { field: "product_code", header: "Product Code" },
      { field: "reasoncode", header: "Reason Code" },
      { field: "gttEvent", header: "GTT Event" },
      { field: "eventcode", header: "Event Code" },
      { field: "photo_delivery_flow", header: "DIA" },
    ];
    this.showItemDetails = true;
    this.routesDetails = routesDetails;
    this.itemDetailsPopupInfo = {
      title : 'Failed Items',
      itemState: ItemState.FailedAttempt
    }
  }

  /**
   *
   * @param routeEndTime Route End Time
   * @returns Return End Time based on if the route end time window
   * is going nextDay + 1
   */
  handleEndTimeBeyondTimeline(routeEndTime: any) {
    if (!routeEndTime || Number.isNaN(new Date(routeEndTime).getTime())) {
      return this.maxDate;
    }
    const formattedEndTime: any = this.datePipe.transform(
      routeEndTime,
      "MM/dd/yyyy, HH:mm"
    );
    const formattedMax: any = this.datePipe.transform(
      this.maxDate,
      "MM/dd/yyyy, HH:mm"
    );
    if (formattedEndTime >= formattedMax) {
      return this.maxDate;
    } else {
      return routeEndTime;
    }
  }

  /**
 * Export the Kpi data to an Excel file. 
 */
 exportExcel(kpiTable:Table) {
   const tableData = kpiTable.filteredValue ? kpiTable.filteredValue : kpiTable.value;
  if (!tableData || tableData.length === 0) {
   this.messageService.add({ severity: ErrorType.ERROR, closable: false, summary: '', detail: ErrorMessage.NODATA,});
     return;
  }
  const columnVisible = this.visibleColumns.map(col => col.label);
 
  const exportData = tableData.map((row: any) => {
    const fullData: any = {
      Route: row.route_label || '',
      Status: row.route_state || '',
      Stops: `${this.kpiProgress.transform(row, 'stops')}/${row.kpi?.stops?.total ?? 0}`,
      Tasks: `${this.kpiProgress.transform(row, 'tasks')}/${row.kpi?.tasks?.total ?? 0}`,
      Items: `${this.kpiProgress.transform(row, 'items')}/${row.kpi?.items?.total ?? 0}`,
      'Completed%': `${row.kpi?.tasks?.completedPercentage ?? 0}%`,
      'Loaded/ Planned': `${row.kpi?.items?.total_loaded ?? 0}/${row.kpi?.items?.planned_at_sorting ?? 0}`,
      'Moved in/out': `${row.kpi?.items?.items_moved_in ?? 0}/${row.kpi?.items?.items_moved_out ?? 0}`,
      'Planned After Load Start': row.kpi?.items?.planned_at_loading ?? 0,
      Pickup: row.kpi?.tasks?.pickup ?? 0,
      Workshift: row.workshift_name || '',
      'Tasks Left': row.kpi?.tasks?.tasks_left ?? 'NA',
      'Tasks/h': row.kpi?.tasks?.tasks_pr_hour ?? 'NA',
      Weight: row.kpi?.items?.weight ?? 0,
      Volume: row.kpi?.items?.volume ?? 0,
      Vehicle : row.vehicle?.reg_no || '',
      '+/- Task': row.kpi.tasks.task_workload_variance > 0 ? "+"+row.kpi.tasks.task_workload_variance :
                  row.kpi.tasks.task_workload_variance,
      'Container Count': row.container_information.container_count
    };
 
    const rowData: any = {};
    columnVisible.forEach(col => {rowData[col] = fullData[col] ?? ''; });
    return rowData;
  });
 
  const fileName = ExportToExcelService.toExportFileName('RouteList');
  this.exportToExcelService.exportAsExcelFile(exportData, fileName);
}

  drawCurrentTimeLine(svg: any, headerSVG: any) {
    svg.selectAll(".current-time-line").remove();
    headerSVG.selectAll(".current-time-label").remove();
    const now = new Date();
    const xPos = this.x(now) + 20.5;

    svg.append("line")
      .attr("class", "current-time-line")
      .attr("x1", xPos)
      .attr("x2", xPos)
      .attr("y1", 0)
      .attr("y2", this.height)
      .style("stroke", "#FF009D")
      .style("stroke-width", "1.5px");

    const labelGroup = headerSVG.append("g")
      .attr("class", "current-time-label")
      .attr("transform", `translate(${xPos}, 16)`)
      .style("font-family", "PNSans-Regular, sans-serif")
      .style('font-size','12px');

    labelGroup.append("rect")
      .attr("width", 60)
      .attr("height", 18)
      .attr("fill", "#FF009D")
      .attr("rx", 3)
      .attr("ry", 3);

    labelGroup.append("text")
      .attr("x", 30)
      .attr("y", 14)
      .attr("text-anchor", "middle")
      .style("font-size", "11px")
      .style("fill", "white")
      .text(d3.timeFormat("%H:%M")(now));
  }

  drawVerticalGrid(svg: any, xScale: any, height: number) {
    const grid = svg.append("g")
      .attr("class", "vertical-grid")
      .attr("transform", `translate(${this.margin.left}, -20)`)
      .call(
        d3.axisTop(xScale)
          .ticks(d3.timeHour.every(2))
          .tickSize(-height)
      )
    grid.selectAll(".domain").remove();

    grid.selectAll("line")
      .style("stroke", "#9e9e9e")
      .style("stroke-width", "0.5")
      .style("stroke-dasharray", "3 3");
  }

  /**
   * to render gantt chart
   */
  renderGanttChart() {
    // Keep table + gantt in sync using the same filtered list.
    const baseList = this.getSearchFilteredRoutes();
    // Sort mutates, so always sort a copy.
    this.routeList = baseList.slice();

    if (this.currentSortField && this.currentSortOrder !== 0) {
      this.sortTableData();
    }

    this.removeChart();
    this.calculateDimension();
    this.createGanttChart();
    this.syncGanttToTableRowHeight();
  }

  /**
   * After the chart is drawn, re-measure the rendered row height once the table
   * has painted and redraw if it differs from what we drew with. This corrects
   * the first render, where the row height is only known after the rows paint.
   */
  private syncGanttToTableRowHeight() {
    requestAnimationFrame(() => {
      const measured = this.measureTableRowHeight();
      if (measured > 0 && Math.abs(measured - this.rowHeight) > 0.5) {
        this.rowHeight = measured;
        this.removeChart();
        this.calculateDimension();
        this.createGanttChart();
      }
    });
  }


  /**
   * Returns the default timeline index for a fresh gantt render.
   */
  getDefaultTimelineIndex(): number {
    return 5;
  }

  /**
   * clearSearch() call the method to reset or clear any search-related input,
   * call the 'filterData(null)' method with null as an argument to reset or remove any applied filter.
   */
  clearSearchAndReset() {
    this.clearSearch();
  }
    /**
   * The 'clearSearch' method resets the search text to an empty string.
   */
  clearSearch() {
    this.searchText = "";
    this.renderGanttChart();
  }
  
  onSearchInput(event: Event) {
    const value = (event.target as HTMLInputElement).value || '';
    this.searchText = value;
    this.renderGanttChart();
  }
  /**
   * this method is called on click of moved in out column to open the dialog with details of moved in and moved out items.
   */
  openMovedInOutItemsDialog(kpiData: any): void {
    if (kpiData?.kpi?.items?.items_moved_in > 0 || kpiData?.kpi?.items?.items_moved_out > 0) {
      this.routesDetails = kpiData;
      this.displayMovedInTasksDialog = true; 
    } else return;
  }
  /**
   * this method is called on click of planned after loading column to open the dialog with details of items
  */
  openPlannedAtLoadingItemsDialog(kpiData: any): void {
    if (kpiData?.kpi?.items?.planned_at_loading > 0) {
      this.routesDetails = kpiData;
      this.displayPlannedAtLoadingDialog = true; 
    } else return;
  }

  /**
   * handle merge task on click event
   * @returns 
   */
  handleMergeTaskClick() {
    if (this.selectedRow?.route_state?.toLowerCase() === RouteState.Onroute?.toLowerCase() || this.selectedRow?.route_state?.toLowerCase() === RouteState.Completed?.toLowerCase()) {
      this.messageService.add({ severity: ErrorType.WARNING, closable: false, detail: 'Can not merge tasks while route is On-Route or Completed.' });
      return;
    }
    if (!(this.selectedRow?.kpi?.tasks?.deliver > 0)) {
      this.messageService.add({ severity: ErrorType.WARNING, closable: false, summary: '', detail: ErrorMessage.NO_DELIVER_TASKS });
      return;
    }
    this.showMergeTaskDialog = true;
  }
  
}